export default function isVisible(elem, isScrolled = false) {
  const elementBoundary = elem.getBoundingClientRect();
  const { top } = elementBoundary;
  const { bottom } = elementBoundary;

  if (isScrolled) return bottom <= window.innerHeight;

  return (top <= window.innerHeight);
}
